const referrals = [
	{
		path: '/referrals/reward-tiers',
		name: 'referrals-reward-tiers-list',
		component: () => import(/* webpackChunkName: "ReferralsRewardTiers" */ '@/views/referrals/rewardTiers/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
	{
		path: '/referrals/conversions',
		name: 'referrals-conversions-list',
		component: () => import(/* webpackChunkName: "ReferralsConversions" */ '@/views/referrals/conversions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
]

export default referrals
